﻿function formatThousand(szIn) {
	var sz = szIn;
	var szNew = '';
	while (sz.length > 3) {
		if (szNew != '') szNew = '.' + szNew;
		szNew = sz.slice((sz.length - 3), sz.length) + szNew;
		sz = sz.slice(0, (sz.length - 3));
	}

	if (szNew != '') szNew = '.' + szNew;
	szNew = sz + szNew;
	return (szNew);
}

function FormatMoney(amt) {
	var tmpn = 0;
	var tmps = "";
	tmpn = Math.round(amt * 100);

	//Add comma and 2 numbers to the end
	if (tmpn < 0 || tmpn > 99999999999999)
		return "*********";
	else if (tmpn < 10)
		tmps = "00" + tmpn;
	else if (tmpn < 100)
		tmps = "0" + tmpn;
	else tmps = "" + tmpn;

	var before = formatThousand(tmps.substring(0, (tmps.length - 2)));
	return before + "," + tmps.substring((tmps.length - 2), tmps.length);
}

function strip(n, s) {
	var pos = 0;
	var len = n.length;
	var res = '';
	while (pos < len) {
		if (s.indexOf(n.charAt(pos)) != -1)
			res += n.charAt(pos);

		pos++;
	}
	return (res);
}
window.strip = strip;

function fixfloat(n) {
	var pos;
	var inp;
	var flp;
	var res;

	pos = n.indexOf(',');

	if (pos == -1)
		pos = n.indexOf('.');

	// comma in string
	if (pos != -1) {
		inp = strip(n.substring(0, pos), '0123456789');
		flp = strip(n.substring(pos + 1), '0123456789');

		if (inp && flp) //num, commanum
			return eval(inp) + flp / Math.pow(10, flp.length);
		else {
			if (!inp && flp) //commanum
				return flp / Math.pow(10, flp.length);
			else {
				if (!inp && !flp) //not num, not commanum
					return '';
				else if (inp && !flp) //num
					return eval(inp);
			}
		}
	}
	return (strip(n, '0123456789'));
}

window.fixfloat = fixfloat;

function getElement(sElement) {
	var oElement = null;
	if (document.getElementById) {
		if (document.getElementById(sElement))
			oElement = document.getElementById(sElement);
	}
	else if (document.all) {
		if (document.all(sElement))
			oElement = document.all(sElement);
	}
	else if (document.layers) {
		if (document.layers[sElement])
			oElement = document.layers[sElement];
	}
	return oElement;
}

//*** LI validation function used in javascript validation of controls and in calculators and applications **/
function LI_validateKennitala(val) {
	var gildi = val;
	if (val && val.IDToEval)
		gildi = getElement(val.IDToEval).value;
	return LI_validateKennitalaValue(gildi);
}

window.LI_validateKennitala = LI_validateKennitala;

function LI_validateKennitalaValue(gildi) {
	if (gildi.length == 0) return true;
	var bReg = false;
	var regex = new RegExp("^([0-9]{6})(-?)([0-9]{3})[890]$");
	bReg = regex.test(gildi);

	if (!bReg)
		return false;

	if (gildi.length > 9 || gildi.length < 12) {
		if (gildi.length == 11) //ef það er bandstrik
			gildi = gildi.replace("-", "");

		var nSumma = 0;
		nSumma = parseInt(gildi.substr(0, 1)) * 3 + parseInt(gildi.substr(1, 1)) * 2 +
			parseInt(gildi.substr(2, 1)) * 7 + parseInt(gildi.substr(3, 1)) * 6 +
			parseInt(gildi.substr(4, 1)) * 5 + parseInt(gildi.substr(5, 1)) * 4 +
			parseInt(gildi.substr(6, 1)) * 3 + parseInt(gildi.substr(7, 1)) * 2;

		var nVartala = 0;
		nVartala = 11 - (nSumma % 11);

		if (nVartala == 11)
			nVartala = 0;

		if (nVartala != parseInt(gildi.substr(8, 1)))
			return false;
		else
			return true;

	}
	else
		return false;
}

window.LI_validateKennitalaValue = LI_validateKennitalaValue;

function LI_validateEmail(gildi) {
	if (gildi.length == 0)
		return true;
	var regex = new RegExp("^(([A-Za-z0-9]+_+)|([A-Za-z0-9]+\\-+)|([A-Za-z0-9]+\\.+)|([A-Za-z0-9]+\\++))*[A-Za-z0-9]+@(([A-Za-z0-9_]+\\-+)|([A-Za-z0-9_]+\\.))*[A-Za-z0-9_]{1,63}\\.[a-zA-Z]{2,6}$");
	return regex.test(gildi);
}

window.LI_validateEmail = LI_validateEmail;

function regxValidatePhone(val) {
	if (val.length > 0) {
		return /^[+]?([0-9]*[\.\s\-\(\)]|[0-9]+){6,24}$/.test(val);
	}
	else
		return true;
}

function regxValidatePostalcode(val) {
	if (val.length > 0) {
		return /^[1-9][0-9]{2}/.test(val);
	}
	else
		return true;
}

function regxValidateAccount(val) {
	if (val.length > 0) {
		var regex = new RegExp("^[0-9]{3,4}[-\s]{1}[0-9]{2}[-\s]{1}[0-9]{1,6}$");
		return regex.test(val);
	}
	else
		return true;
}

//** Li validation ends **//

//Ajax framework uses this to display errors
var webFramework = {
	displayError: function (message) {
		var errorBox = $("#ErrorBox_PanelBox");
		errorBox.slideUp(function () {
			errorBox.find('h2').text(message).end().slideDown();
		});
	}
};

(function ($) {
	// Autogrow textarea
	$.fn.autogrow = function (options) {
		return this.each(function () {
			$(this).bind('keyup', function (e) {
				if ($(this).val().length < $(this).attr("maxlength")) {
					var box = $(this),
						text = box.val(),
						height = parseInt(box.css('height').replace('px', ''), 10),
						newheight = box.attr('scrollHeight');

					if (text.length > 0 && height + 4 < newheight) {
						box.css({ height: newheight });
					}
				}
			});
		});
	};
})(jQuery);

